import styled from 'styled-components';

import { useTranslate } from '@dreryk/react-common';

import { HistoricalVisitPrintItemData } from './historicalVisits.types';

type HistoricalVisitPrintItemProps = {
   readonly print: HistoricalVisitPrintItemData;
};

const StyledHistoricalVisitPrintItemWrapper = styled.div`
   display: flex;
   justify-content: space-between;

   & > p {
      margin: 0.2em 0;
   }
`;
StyledHistoricalVisitPrintItemWrapper.displayName = 'StyledHistoricalVisitPrintItemWrapper';

const HistoricalVisitPrintItem = (props: HistoricalVisitPrintItemProps): JSX.Element | null => {
   const translate = useTranslate();

   return (
      <StyledHistoricalVisitPrintItemWrapper>
         <p>{translate(props.print.label)}</p>
      </StyledHistoricalVisitPrintItemWrapper>
   );
};

export { HistoricalVisitPrintItem };
